export default __webpack_public_path__ + "static/media/General news logo.8679f19a.png";